export const CategoryNameMap = {
  LEAD: 'When I’m the Lead',
  MEMBER: 'When I’m a team member',
  NON_MEMBER: 'When not on projects'
};